module.exports = __webpack_public_path__ + "pic/65.c45d5d4f.png";